import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pigmy-creation-grid',
  templateUrl: './pigmy-creation-grid.component.html',
  styleUrls: ['./pigmy-creation-grid.component.css']
})
export class PigmyCreationGridComponent implements OnInit {
  title="PigmyCreationList"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/accountmaster/pigmy-creation-grid/pigmy-creation-grid.component.ts